<header id="header">
  <div class="container">
    <!-- Begin Logo -->
    <a routerLink="/" title="Home" rel="home" id="logo">
      <img [src]="logoUrl" [attr.alt]="(nameBranch ? nameBranch + ' ' : '') + (isAdmin ? 'Certification Centre logo' : 'Resource Centre logo')" style="min-height: 60px;" [style.maxWidth]="'250px'" [style.height]="'90px'">
    </a>
    <!-- End Logo -->
    <div id="site-name">
      <h1 class="title"><span>{{nameBranch}}</span> {{isAdmin ? 'Certification Centre' : 'Resource Centre'}} </h1>
    </div>
  </div>
  <div class="clearfix"></div>

  <div class="login-banner" *ngIf="isAuthenticated">
    <div class="container login-banner__inner">
      <div class="login-banner__message">You are logged in as <strong>{{ displayName }}</strong></div>
      <div class="login-banner__actions">
        <a routerLink="/changepassword"><i class="glyphicon glyphicon-lock"></i> Change Password</a>
        <a href="/preferences"><i class="glyphicon glyphicon-cog"></i> Preferences</a>
        <button type="button" class="login-banner__action-btn" (click)="logout()"><i class="glyphicon glyphicon-log-out"></i> Logout</button>
      </div>
    </div>
  </div>
</header>
